/**
 * Auth-related localStorage keys only. Used for quiet logout on the public
 * portal so tenant branding / language caches from ThemeContext are preserved.
 */
const AUTH_LOCAL_STORAGE_KEYS = [
  "auth_token",
  "refresh_token",
  "userType",
  "userDetails",
  "user_profile_id",
  "tenant_id",
  "tenant_name",
  "sidebarComponents",
  "auth_event",
  "logout_reason",
  "payment_id",
  "redirectAfterLogin",
  "remembered_email",
  "remembered_password",
  "remembered_timestamp",
  "transactionOffset",
];

export const clearAuthLocalStorage = () => {
  AUTH_LOCAL_STORAGE_KEYS.forEach((key) => {
    localStorage.removeItem(key);
  });
};
